<template>
    <div class="container">
        <div class="field">
            <p v-text="lang('Le presenti autorizzazioni sono neccessarie al fine di ottemperare alla normativa Europea in materia di Privacy, denominata GDPR. Vi ricordiamo che solamente l\'accettazione dell\'informativa della Privacy è obbligatoria.')"></p>
        </div>
        <div class="quotes-form-policies">
        <div class="contact-policies">
            <div class="policy-card">
                <h4 v-text="lang('Informativa sulla Privacy')"></h4>
                <p>{{ lang('Desideriamo informarVi le modalità di conservazione dei vostri dati, incluso le finalità e tempistiche. In ogni momento sarà possibile visualizzare i dati in nostro possesso, modificarli e richiederne la cancellazione. Per poter procedere con l\'invio del presente form è obbligatorio acconsentire alla nostra Informativa sulla privacy, che può essere consultata in maniera completa al seguente link')}} <a target="_blank" href="/policies/privacy">https://www.daku.it/policies/privacy</a>
                </p>
                <checkbox name="privacy" :errors="policyErrors" v-model="input.privacy">
                    <span v-text="lang('Acconsento al trattamento dei miei dati come riportato nella')"></span> <a target="_blank" href="/policies/privacy">Informativa della Privacy</a> di Daku Italia S.r.l
                </checkbox>
            </div>
            <div class="policy-card">
                <h4 v-text="lang('Iscrizione alla newsletter')"></h4>
                <p v-text="lang('Con l\'obbiettivo di informare i nostri clienti sulle ultime novità nell\'ambito del Verde Pensile, inviamo con cadenza mensile tramite email comunicazioni di tipo informativo. Sei interessato a riceve la nostra newsletter?')"></p>
                <checkbox name="newsletter" :errors="policyErrors" v-model="input.newsletter">
                    <span v-text="lang('Desidero iscrivermi alla newsletter di Daku Italia')"></span>
                </checkbox>
            </div>
            <div class="policy-card">
                <h4 v-text="lang('Contatto commerciale')"></h4>
                <p v-text="lang('Attraverso l\'invio del seguente form è previsto un contatto diretto con un nostro consulente commerciale di zone. Desideri ricevere ulteriori comunicazioni commerciali da parte di Daku Italia S.r.l, all\'infuori dello scopo del seguente form?')"></p>
                <checkbox name="contact" :errors="policyErrors" v-model="input.contact">
                    <span v-text="lang('Si, desidero ricevere ulteriori comunicazioni commerciali da parte di Daku Italia S.r.l')"></span>
                </checkbox>
            </div>
        </div>
        <div class="field has-text-centered">
            <button @click.prevent="send"
                    class="button is-primary"
                    v-text="lang('Richiedi il tuo Preventivo')"></button>
        </div>
    </div>
    </div>
</template>
<script>
    import FormErrors from "../Classes/FormErrors";

    export default {
        props: {
            value: {
                type: Object,
                required: false
            },
            errors: {
                type: Object,
                required: true
            }
        },
        mounted() {
            if( typeof value === 'object') this.input = value
        },
        data() {
            return {
                input: {
                    privacy: false,
                    contact: false,
                    newsletter: false
                },
                policyErrors: new FormErrors()
            }
        },
        methods: {
            send() {
                this.$emit('send')
            }
        },
        watch: {
            input: {
                handler( input ) {
                    this.$emit('input', input)
                },
                deep: true
            },
            value( value ) {
                if( typeof value === 'object') this.input = value
            },
            errors( errors ) {
                if( errors.policies ) {
                    this.policyErrors.record( errors.policies );
                }
            }
        }
    }
</script>